/* Impression SCDM - mm, cm ou po dans le format personnalise.

   POURQUOI CE FICHIER EXISTE
   --------------------------
   Les deux champs du format personnalise etaient en pouces, point. Un client
   qui a ses mesures en millimetres devait convertir lui-meme - c est
   exactement le genre de calcul mental ou on se trompe d un facteur 10 et ou
   on decouvre l erreur en deballant la commande.

   COMMENT CA MARCHE SANS TOUCHER A scdm.js
   ----------------------------------------
   scdm.js lit directement la valeur des champs et la traite comme des pouces.
   On ne peut donc pas juste changer l unite affichee. Mais scdm.js expose
   window.SCDM.etat : on ecrit donc la valeur CONVERTIE dans etat.larg et
   etat.haut apres son propre gestionnaire, puis on relance le calcul.

   Le rafraichissement se declenche en simulant un changement sur le menu de
   format : c est le seul point d entree public qui rappelle rafraichir(), et a
   ce moment l etat porte deja les bonnes valeurs en pouces. Les deux
   gestionnaires tournent dans le meme evenement, donc l affichage intermediaire
   n est jamais peint - le client ne voit qu un seul resultat, le bon.

   ==================================================================
   DIM-01 — LA DIMENSION NE DOIT PLUS BOUGER QUAND ON CHANGE D UNITE
   Corrige le 12 septembre 2026, releve dans l audit du proprietaire.
   ==================================================================

   CE QUI SE PASSAIT. L ancienne version arrondissait la valeur AFFICHEE, puis
   relisait ce champ arrondi pour recalculer les pouces. L arrondi devenait donc
   la nouvelle verite, et chaque aller-retour rognait la mesure :

       4 x 6 po, 25 pieces ......... 91,22 $
       passe en mm : 102 x 152 ..... 91,28 $
       revenu en po : 4,02 x 5,98 .. 91,29 $

   Le client n avait rien touche et il avait changé de format, de prix, et de
   fichier de production. 6 po etaient devenus 5,98 po parce que 152,4 mm
   avaient ete affiches « 152 ».

   CE QU ON FAIT MAINTENANT, ET C EST TOUT LE CORRECTIF.

   1. LA MESURE EXACTE VIT EN POUCES, DANS exactL et exactH. C est la seule
      verite. Les champs ne sont qu un affichage.
   2. CHANGER D UNITE NE TOUCHE JAMAIS A exactL ni exactH. On repeint les
      champs, on repousse la MEME mesure. Le prix ne peut donc pas bouger : ce
      n est plus une question d arrondi bien regle, c est qu il n y a plus rien
      a arrondir sur le chemin.
   3. SEULE UNE FRAPPE DU CLIENT change la mesure. C est la seule fois ou
      relire le champ a un sens.
   4. L AFFICHAGE GARDE ASSEZ DE DECIMALES pour rester honnete : 6 po s ecrit
      152,4 mm, pas 152. Un client qui lit 152,4 et le retape retombe sur
      6 po. Sans cette decimale, le champ afficherait une mesure qui n est pas
      celle qui sera imprimee.
   5. step="any" DEVIENT OBLIGATOIRE. Avec l ancien pas de 5 mm, 152,4 aurait
      ete marque invalide par le navigateur. Les fleches perdent leur pas rond ;
      une mesure juste vaut mieux qu une fleche commode.

   A FAIRE UN JOUR : integrer l unite directement dans scdm.js et supprimer ce
   fichier. Il est ici pour eviter de reecrire 39 Ko pour une conversion. */

(function () {

  function texteUnites(cle, repli, params) {
    var racine = document.getElementById('scdmUnitesI18n');
    var texte = racine && racine.getAttribute('data-unites-' + cle);
    return (texte || repli).replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  function htmlUnites(texte) {
    return String(texte).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function quandPret(cb, n) {
    if (window.SCDM && window.SCDM.etat) return cb();
    if ((n || 0) > 100) return;
    setTimeout(function () { quandPret(cb, (n || 0) + 1); }, 50);
  }

  quandPret(function () {
    var dims = document.getElementById('scdmDims');
    var L = document.getElementById('scdmLargeur');
    var H = document.getElementById('scdmHauteur');
    var sel = document.getElementById('scdmTaille');
    if (!dims || !L || !H || !sel) return;

    var VERS_PO = { po: 1, cm: 1 / 2.54, mm: 1 / 25.4 };
    var MINI    = { po: 0.5, cm: 1.3, mm: 13 };

    /* Combien de decimales on affiche par unite. Assez pour qu un aller-retour
       retombe sur la meme mesure : 6 po -> 152,4 mm -> 6 po. */
    var DECIMALES = { po: 3, cm: 2, mm: 1 };

    var unite = 'po';

    /* LA VERITE, EN POUCES. Tout le reste n est que de l affichage. */
    var exactL = Number(L.value) || 0;
    var exactH = Number(H.value) || 0;

    /* On remplace l etiquette figee "po" par un vrai selecteur. */
    var groupe = document.createElement('span');
    groupe.className = 'unites dims-unites';
    groupe.setAttribute('role', 'group');
    groupe.setAttribute('aria-label', texteUnites('dimension_unit', 'Unite des dimensions saisies'));
    groupe.innerHTML = ['po', 'cm', 'mm'].map(function (u) {
      var actif = (u === 'po');
      return '<button type="button" class="uni' + (actif ? ' on' : '') +
             '" data-u="' + u + '" aria-pressed="' + actif + '">' + htmlUnites(texteUnites('unit_' + u, u)) + '</button>';
    }).join('');

    var etiquette = dims.querySelector('.u');
    if (etiquette && etiquette.parentNode) etiquette.parentNode.replaceChild(groupe, etiquette);
    else dims.appendChild(groupe);

    /* Ecrit une mesure dans un champ, sans zero inutile : 152,4 et non 152,400,
       6 et non 6,000. */
    function afficher(champ, pouces) {
      var v = pouces / VERS_PO[unite];
      var t = v.toFixed(DECIMALES[unite]);
      if (t.indexOf('.') !== -1) t = t.replace(/0+$/, '').replace(/\.$/, '');
      champ.value = t;
    }

    /* Vrai pendant que c est NOUS qui relancons le calcul. Sans ce drapeau, le
       gardien pose plus bas sur le meme evenement « change » se declencherait
       sur notre propre relance et se battrait avec nous. */
    var relanceInterne = false;

    /* Pousse la mesure EXACTE vers scdm.js. Jamais ce qui est affiche. */
    function pousser() {
      window.SCDM.etat.larg = exactL;
      window.SCDM.etat.haut = exactH;
      relanceInterne = true;
      try {
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        relanceInterne = false;
      }
    }

    /* Le client a tape : c est la seule fois ou le champ fait autorite. */
    function saisie() {
      exactL = (Number(L.value) || 0) * VERS_PO[unite];
      exactH = (Number(H.value) || 0) * VERS_PO[unite];
      pousser();
    }

    L.addEventListener('input', saisie);
    H.addEventListener('input', saisie);

    function poserPas() {
      /* step="any" : voir le point 5 de l en-tete. Sans lui, 152,4 mm serait
         refuse par le navigateur a cause d un pas de 5. */
      L.step = H.step = 'any';
      L.min = H.min = MINI[unite];
      L.setAttribute('aria-label', texteUnites('width', 'Largeur en {unit}', { unit: texteUnites('unit_' + unite, unite) }));
      H.setAttribute('aria-label', texteUnites('height', 'Hauteur en {unit}', { unit: texteUnites('unit_' + unite, unite) }));
    }
    poserPas();

    groupe.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-u]') : null;
      if (!b) return;
      var neuf = b.getAttribute('data-u');
      if (neuf === unite) return;

      /* On change d unite, PAS de mesure. exactL et exactH ne sont pas
         touches : on ne fait que les reecrire dans l autre unite. */
      unite = neuf;
      afficher(L, exactL);
      afficher(H, exactH);
      poserPas();

      Array.prototype.forEach.call(groupe.querySelectorAll('button'), function (x) {
        var actif = (x === b);
        x.classList.toggle('on', actif);
        x.setAttribute('aria-pressed', actif ? 'true' : 'false');
      });

      /* On repousse quand meme : le format affiche ailleurs sur la page doit
         suivre l unite, et la mesure envoyee reste identique au pouce pres. */
      pousser();

      /* Les cotes sous l apercu passent dans la meme unite : deux unites
         differentes affichees en meme temps, c est comme ca qu on se trompe. */
      var jumeau = document.querySelector('.cotes-barre .unites [data-val="' + unite + '"]');
      if (jumeau) jumeau.click();
    });

    /* Si scdm.js change les dimensions de son cote — choix d un format de la
       liste, chargement d un modele — notre verite doit suivre, sinon le
       prochain changement d unite ressusciterait l ancienne mesure. */
    sel.addEventListener('change', function () {
      if (relanceInterne) return;
      setTimeout(function () {
        var e = window.SCDM && window.SCDM.etat;
        if (!e) return;
        if (Math.abs((e.larg || 0) - exactL) > 1e-9 || Math.abs((e.haut || 0) - exactH) > 1e-9) {
          exactL = e.larg || 0;
          exactH = e.haut || 0;
          afficher(L, exactL);
          afficher(H, exactH);
        }
      }, 0);
    });

    L.setAttribute('aria-label', texteUnites('width', 'Largeur en {unit}', { unit: texteUnites('unit_po', 'po') }));
    H.setAttribute('aria-label', texteUnites('height', 'Hauteur en {unit}', { unit: texteUnites('unit_po', 'po') }));
  });
})();
